import { render, staticRenderFns } from "./delivery-contract-panel.vue?vue&type=template&id=72421297"
import script from "./delivery-contract-panel.vue?vue&type=script&lang=js"
export * from "./delivery-contract-panel.vue?vue&type=script&lang=js"
import style0 from "./delivery-contract-panel.vue?vue&type=style&index=0&id=72421297&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports